/* eslint-disable */
export default function (router) {
  router.map({
    '/wxjeeshare/login': {
      name: 'login',
      component(resolve) {
        require(['./components/login'], resolve);
      }
    },
    '/wxjeeshare/register': {
      name: 'register',
      component(resolve) {
        require(['./components/register'], resolve);
      }
    },
    '/wxjeeshare/search': {
      name: 'search',
      component(resolve) {
        require(['./components/search'], resolve);
      }
    },
    '/wxjeeshare/salarylist': {
      name: 'salarylist',
      component(resolve) {
        require(['./components/salary-list'], resolve);
      }
    },
  '/wxjeeshare/CBLsalarylist': {
    name: 'CBLsalarylist',
      component(resolve) {
      require(['./components/CBL-salary-list'], resolve);
    }
  },
    '/wxjeeshare/salarytest': {
      name: 'salarytest',
      component(resolve) {
        require(['./components/salary-test'], resolve);
      }
    },
    '/wxjeeshare/companyIntr': {
      name: 'companyIntr',
      component(resolve) {
        require(['./components/company-introduction'], resolve);
      }
    },
    '/wxjeeshare/companyMap': {
      name: 'companyMap',
      component(resolve) {
        require(['./components/company-address'], resolve);
      }
    },
    '/wxjeeshare/contactUs': {
      name: 'contactUs',
      component(resolve) {
        require(['./components/contact-us'], resolve);
      }
    },
    '/wxjeeshare/fantasy/register': {
      component(resolve) {
        require(['./components/fantasy/register'], resolve);
      }
    },
    '/wxjeeshare/fantasy/search': {
      component(resolve) {
        require(['./components/fantasy/search'], resolve);
      }
    },
    '/wxjeeshare/fantasy/salarylist': {
      component(resolve) {
        require(['./components/fantasy/salary-list'], resolve);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/router.js